import { render, staticRenderFns } from "./PortePanel.vue?vue&type=template&id=79d3c522&scoped=true&"
import script from "./PortePanel.vue?vue&type=script&lang=ts&"
export * from "./PortePanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d3c522",
  null
  
)

export default component.exports